module.exports = __webpack_public_path__ + "static/media/volunteer1.251db513.webp";